import { FC } from "react";
import { IconProps } from "./types";

export const ArrowRightCircleLine: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M13.155 6a.58.58 0 0 1 .41.17l5.391 5.415a.605.605 0 0 1 .126.64.58.58 0 0 1-.126.19l-5.388 5.415a.595.595 0 0 1-.638.127.574.574 0 0 1-.316-.316.586.586 0 0 1 .126-.636l4.398-4.419H5.458a.581.581 0 0 1-.583-.585.587.587 0 0 1 .583-.586h11.684l-4.398-4.419A.585.585 0 0 1 13.155 6z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.39 2.721a12 12 0 1 1 15.22 18.557A12 12 0 0 1 4.39 2.721zM5.957 21.05a10.884 10.884 0 0 0 6.047 1.834 10.898 10.898 0 0 0 10.884-10.883A10.884 10.884 0 1 0 5.957 21.05z"
      fill={fill}
    />
  </svg>
);
